// extracted by mini-css-extract-plugin
module.exports = {"base":"fiveOpinionStories-m__base__3dWrD","en-container":"fiveOpinionStories-m__en-container__34fy4","container":"fiveOpinionStories-m__container__1mXRm"};